import { HttpDataService } from '../../../../shared/http/http-data.service';

import { IContact } from '../../../../../type_definitions/datatypes';
import { IRequesterAddress } from '../order-entry-data.service';
import { OrderEntryWebshopService } from '../webshop/order-entry-webshop.service';
import { Injectable } from '@angular/core';

export interface IRequester extends IContact {
  address:IRequesterAddress;
}

@Injectable()
export class OrderEntryRequesterDataService {
  constructor(
    private httpDataService:HttpDataService,
    private orderEntryWebshopService:OrderEntryWebshopService
  ) {
    /***/
  }

  public requester(requesterId:number):Promise<IContact> {
    return this.httpDataService.doGET(
      `rest/orderentry/webshops/${this.orderEntryWebshopService.selectedShop.id}/requesters/${requesterId}`,
      undefined,
      undefined,
      'Error loading requester'
    );
  }
}